module.exports = __webpack_public_path__ + "media/images/og_image_default-c58599f1d7a432fcfe0c8e4d94a264cc.png";